import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function subDayOffReducer() {
    return combineReducers({
        WorkHoliday_ListForBossTotalPoNew: createItemReducer("SubDayOff", "WorkHoliday.ListForBossTotalPoNew", false),
        WorkHoliday_ListForBossTotalPoNewParams: createItemReducerParams("SubDayOff", "WorkHoliday.ListForBossTotalPoNew")
    });
}